import { useCallback } from 'react';
import { ChatService } from '../lib/chatService';
import { chatEventBus } from '../lib/chatEventBus';
import { useChatStore } from '../stores/chatStore';
import { useToast } from '../context/ToastContext';

/**
 * Shared hook for sending images to chat
 * This ensures all chat button implementations follow the same rules
 */
export const useSendToChat = (projectId?: string) => {
    const { showToast } = useToast();
    const addPendingMessage = useChatStore(state => state.addPendingMessage);

    const sendToChat = useCallback(async (imageUrl: string) => {
        if (!projectId) {
            showToast('Please select a project first', 'error');
            return;
        }

        try {
            console.log('📤 Sending image to chat:', imageUrl, 'Project:', projectId);
            const message = await ChatService.sendMessage(projectId, '', 'image', imageUrl);
            if (message) {
                console.log('✅ Image sent to chat successfully:', message.id);
                // Add to store for when chat is closed
                addPendingMessage(projectId, message);
                // Notify chat panel immediately via event bus
                chatEventBus.notify(projectId, message);
                showToast('Image sent to chat', 'success');
            } else {
                showToast('Failed to send image to chat', 'error');
            }
        } catch (error) {
            console.error('❌ Failed to send image to chat:', error);
            showToast('Failed to send image to chat', 'error');
        }
    }, [projectId, showToast, addPendingMessage]);

    return sendToChat;
};
